import http from '@/plugins/axios/axios';

export default class ConfiguracaoEscalaService {

    salvar(requisicao) {       
        return http.post('/api/configuracao-escala/salvar', requisicao);
    } 

    alterar(requisicao) {       
        return http.post('/api/configuracao-escala/alterar', requisicao);
    } 

    excluir(requisicao) {       
        return http.post('/api/configuracao-escala/excluir', requisicao);
    } 

    buscar(requisicao) {       
        return http.post('/api/configuracao-escala/buscar', requisicao);
    } 
    
    listar(requisicao) {       
        return http.post('/api/configuracao-escala/listar', requisicao);
    } 

    salvarCiclos(requisicao) {       
        return http.post('/api/configuracao-escala/salvar-ciclos', requisicao);
    } 

    excluirCiclos(requisicao) {       
        return http.post('/api/configuracao-escala/excluir-ciclo', requisicao);
    } 

    listarCiclos(requisicao) {       
        return http.post('/api/configuracao-escala/listar-ciclos', requisicao);
    }
    
    listarDetalhesCiclos(requisicao) {       
        return http.post('/api/configuracao-escala/detalhes-ciclos', requisicao);
    }

    listarSequenciaCiclos(requisicao) {       
        return http.post('/api/configuracao-escala/sequencia-ciclos-escala', requisicao);
    }

    trocarContratoFuncionarios(requisicao) { 
        return http.post('/api/configuracao-escala/trocar-contrato-funcionarios', requisicao);
    }
}